import React from 'react';

import ProductList from '../../../../../components/PolicySelection/ProductList.component';

const ProductsSelectionCards = ({ filterProduct, finishSelection }: any) => {
  return (
    <>
      <ProductList
        header_title="Seleccionar producto"
        subtitle="Accedé a tu documentación"
        filter_product={filterProduct}
        finish_selection={finishSelection}
      />
    </>
  );
};

export default ProductsSelectionCards;
